import { renderContentFromMetadata } from '@jutro/uiconfig';
import metadata from './SgVehicleChangeType.metadata.json5';

function SgVehicleChangeType(props) {
    const {
        activeChangeType,
        setActiveChangeType
    } = props;

    const overrides = {
        vehicleChangeType: {
            value: activeChangeType,
            onValueChange: (newValue) => setActiveChangeType(newValue)
        },
    };
    const resolvers = {};
    return renderContentFromMetadata(metadata.pageContent, overrides, resolvers);
}

export default SgVehicleChangeType;
